import { Injectable } from '@angular/core';
import { Actions, createEffect, Effect, ofType } from '@ngrx/effects';
import { exhaustMap, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { mergePositionsWithUnits, prepareUnitsStats, setUnitsStats, updateUnits } from '../actions/unit-all-data.actions';
import { getUnitAllData } from '../reducers';
import { interval, of } from 'rxjs';
import {Store} from '@ngrx/store';
import {DataGrabber} from '../../../units/services/data-grabber';
import { cacheLifeTime } from '../../../shared/config';
import * as UnitSharedActions from '../actions/units-shared.actions';
import { PositionStatus } from '../../../units/models/position-status';

@Injectable()
export class UnitAllDataEffects {

  prepareUnitsStats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(mergePositionsWithUnits.type, updateUnits.type, prepareUnitsStats.type),
      withLatestFrom(this.store$.select(getUnitAllData)),
      switchMap(([action, unitData]) => {
        const stat = {
          moving: 0,
          parked: 0,
          business: 0,
          private: 0,
          gpsOn: 0,
          gpsOff: 0,
          gsmOn: 0,
          gsmOff: 0,
        };
        for (const item of unitData) {
          if (item.position) {
            if (item.position.status === PositionStatus.MOVING) {
              stat.moving += 1;
            } else {
              stat.parked += 1;
            }
            if (item.position.private) {
              stat.private += 1;
            } else {
              stat.business += 1;
            }
            if (!item.position.positionError) {
              stat.gpsOn += 1;
            } else {
              stat.gpsOff += 1;
            }
            if (item.position.gsmSignalLevel > 8 
                && ((new Date().getTime() - new Date(item.position.date).getTime()) / (1000 * 60)) <= 65) {
              stat.gsmOn += 1;
            } else {
              stat.gsmOff += 1;
            }
          }
        }
        return of(setUnitsStats({unitStats: stat}));
      })
    )
  );

  getGeacoderData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(mergePositionsWithUnits.type),
      withLatestFrom(this.store$.select(getUnitAllData)),
      tap(([action, unitData]) => {
        this.dataGrabber.getGeocoderData(unitData);
      })
    ),
    { dispatch: false }
  );

  @Effect()
  clear = interval(cacheLifeTime).pipe(
    switchMap((action) => of(UnitSharedActions.clearData()))
  );

  constructor(
    private actions$: Actions,
    private store$: Store<any>,
    private dataGrabber: DataGrabber
  ) { }
}
